/* eslint-disable prefer-object-spread, default-param-last */
import { SUBMIT, LAYOUT, MANAGER } from '../constants/action_type';
import Format from '../helpers/format';

const initialState = {
  isAscend: false,
  isIntensity: true,
  decimal: 2,
  operation: { name: 'empty' },
};

const updateOperation = (action) => (
  { operation: action.payload || initialState.operation }
);

const submitReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT.TOGGLE_IS_ASCEND:
      return Object.assign({}, state, { isAscend: !state.isAscend });
    case SUBMIT.TOGGLE_IS_INTENSITY:
      return Object.assign({}, state, { isIntensity: !state.isIntensity });
    case SUBMIT.UPDATE_OPERATION:
      return Object.assign({}, state, updateOperation(action));
    case SUBMIT.UPDATE_DECIMAL:
      return Object.assign({}, state, { decimal: action.payload.target.value });
    case LAYOUT.UPDATE: {
      const decimal = Format.spectraDigit(action.payload);
      return Object.assign({}, state, { decimal });
    }
    case MANAGER.RESETALL: {
      // Same effective layout as reducer_layout, so the precision follows the layout.
      const layout = Format.resetAllLayout(action.payload);
      const decimal = layout ? Format.spectraDigit(layout) : state.decimal;
      return Object.assign({}, state, { decimal, isIntensity: true, isAscend: false });
    }
    default:
      return state;
  }
};

export default submitReducer;
